import React, { useState, useEffect, useRef } from 'react';
import logo from '../../space.webp';
import Cookies from 'universal-cookie';
import './editViews.css';

import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes, _arrayBufferToBase64 } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import clip from './../../img/clip.png';
import home from './../../img/home.png';
import persons from './../../img/profile.png';
import car from './../../img/car.png';
import company from './../../img/company.png';
import crime from './../../img/crime.png';
import phoneInterner from './../../img/phoneInterner.png';
import event from './../../img/event.png';
import documents from './../../img/document.png';
import weapon from './../../img/weapon.png';
import bs from './../../img/bs.png';
import headPhone from './../../img/headphone.png';
import plus from './../../img/plus.png'
import minus from './../../img/minus.png'
import PersonModel from '../models/PersonModel';
import SearchModel from '../models/SearchModel';
import ModelForAdd from '../models/ModelForAdd';

import Person from '../components/Person';
import Address from '../components/Address';
import Company from '../components/Company';
import Auto from '../components/Auto';
import Contact from '../components/Contact';
import Document from '../components/Document';
import Gun from '../components/Gun';
import OPM from '../components/OPM';
import Traitor from '../components/Traitor';
import BS from '../components/BS';
import Kan from '../components/Kan';
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import { Buffer } from 'buffer'
import {
    createChecker, createCheckerLabel, createCheckerInput,
    createPerson, createTraitor, createPersonCollapsed, createTraitorCollapsed,
    createAddressCollapsed, createAutoCollapsed, createCompanyCollapsed, createContactCollapsed,
    createGunCollapsed, createDocCollapsed, createArchCollapsed, createOPMCollapsed, createBSCollapsed, createKanCollapsed,
    showError
} from '../ViewCreator';
import AddressModel from '../models/AddressModel';
import AutoModel from '../models/AutoModel';
import CompanyModel from '../models/CompanyModel';
import ContactModel from '../models/ContactModel';
import DocumentModel from '../models/DocumentModel';
import GunModel from '../models/GunModel';
import OPMModel from '../models/OPMModel';
import TraitorModel from '../models/TraitorModel';
import KanModel from '../models/KanModel';
import BSModel from '../models/BSModel';
import MyDropzone from '../components/MyDropzone';

var modelForAdd = (new ModelForAdd());
var personModel = (new PersonModel());
const cookies = new Cookies();
function KanEdit() {

    var searchModel = new SearchModel();

    const editor = useRef();
    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };

    const [isBlocked, setIsBlocked] = useState(false);

    const blockUI = () => {
        setIsBlocked(true);
    };

    const unblockUI = () => {
        setIsBlocked(false);
    };

    const [type, setType] = useState(0);

    const mainSubmit = () => {
        window.location.href = "/main";
    };

    const addNew = (id, type) => {
        
        clearPersonModel()
        if (type === 20000) {
            var per = new PersonModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.persons.push(per);
        } else if (type === 20001) {
            var per = new AddressModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.addresses.push(per);
        } else if (type === 20002) {
            var per = new AutoModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.auto.push(per);
        } else if (type === 20003) {
            var per = new CompanyModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.company.push(per);
        } else if (type === 20004) {
            var per = new ContactModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.contact.push(per);
        } else if (type === 20005) {
            var per = new DocumentModel()
            per.id = id
            personModel.documents.push(per);
        } else if (type === 20006) {
            var per = new GunModel()
            per.id = id
            personModel.gun.push(per);
        } else if (type === 20008) {
            var per = new OPMModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.opm.push(per);
        } else if (type === 20009) {
            var per = new TraitorModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.traitors.push(per);
        } else if (type === 20010) {
            var per = new KanModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.kan.push(per);
        } else if (type === 20011) {
            var per = new BSModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.bs.push(per);
        } else if (type === 20012){
            var files = id
            for (let index = 0; index < files.length; index++) {
                const reader = new FileReader()
                reader.onabort = () => console.log('file reading was aborted')
                reader.onerror = () => console.log('file reading has failed')
                reader.onload = () => {
                // Do whatever you want with the file contents
                  const binaryStr = reader.result
                  var ex = "";
                  if (files[index].path == undefined) {
                    ex = files[index].name.split('.').pop().toLowerCase();
                  } else {
                    ex = files[index].path.split('.').pop().toLowerCase();
                  }
                  if (ex == 'bmp' || ex == 'gif' || ex == 'jpeg' || ex == 'jpg' || ex == 'tiff' || ex == 'png') {
                    var b = _arrayBufferToBase64(binaryStr)
                    var tt = {
                      image: b,
                      text: ""
                    }
                    personModel.photo.push(tt)
                    
                    
                  } else {
            
            
            
            
            
                    
                    var b = _arrayBufferToBase64(binaryStr)
            
            
            
            
                    
                    var tt = {
                      
                        fileName: files[index].name,
                        file: b,
                      
                      
                      text: "",
                      
                    }

                    
                      personModel.files.push(tt)
                    
                  }

                  sendReSave()
                }
                reader.readAsArrayBuffer(files[index])
              }
           
        } else if (type === 20013){
            var tt = {
                image: id,
                text: ""
              }
            personModel.photo.push(tt)
        }

        if (type !== 20012){
         sendReSave()
        }
    }

    useEffect(() => {
        if (cookies.get('type') != null) {
            var t = cookies.get('type')
            setType(t);
        }
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        sendPerson(id);
    }, []);

    const sendPerson = (id) => {
        var path = ip + '/api/kan/info';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                    
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                    var zz = []

                    var pers = result.data
                    personModel = (pers)
                    setView(pers)

                }
            })
    }

    const profileSubmit = () => {
        allHide();
        document.getElementById("Person").style.display = "block";
        document.getElementById("personsB").className = 'panelButtonActive-kan'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const phoneInternerSubmit = () => {
        allHide();
        document.getElementById("Contact").style.display = "block";
        document.getElementById("phoneInternerB").className = 'panelButtonActive-kan'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const clipSubmit = () => {
        allHide();
        document.getElementById("MyDropzone").style.display = "block";
        document.getElementById("clipB").className = 'panelButtonActive-kan'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const eventSubmit = () => {
        allHide();
        document.getElementById("OPM").style.display = "block";
        document.getElementById("eventB").className = 'panelButtonActive-kan'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const allHide = () => {
        var a = document.getElementsByClassName("menuItems");
        for (let index = 0; index < a.length; index++) {
            a[index].style.display = "none";

        }
        var b = document.getElementsByClassName("panelButtonActive-kan");
        for (let index = 0; index < b.length; index++) {
            b[index].className = 'panelButton-kan'

        }
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }

    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id + "A")
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "AList").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "AList").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id + "A").value = l[index]
                            document.getElementById(id + "AList").innerHTML = "";
                            
                            if (id == 'lineKan') {
                                personModel.lineKan = l[index]
                              }
                              if (id == 'shifrKan') {
                                personModel.shifrKan = l[index]
                              }
                              if (id == 'dateComingsKan') {
                                personModel.dateComingsKan = l[index]
                              }
                              if (id == 'dateBeginKan') {
                                personModel.dateBeginKan = l[index]
                              }
                              if (id == 'dateEndKan') {
                                personModel.dateEndKan = l[index]
                              }
                              if (id == 'addressKan') {
                                personModel.addressKan = l[index]
                              }
                              if (id == 'jobKan') {
                                personModel.jobKan = l[index]
                              }
                              if (id == 'descKan') {
                                personModel.descKan = l[index]
                              }
                              if (id == 'infoKan') {
                                personModel.infoKan = l[index]
                              }
                
                        }
                        document.getElementById(id + "AList").appendChild(z);

                    }
                }
            })








    }


    const jobchange = () => {
        personModel.jobKan = document.getElementById('jobKanA').value
        changedfield('jobKan');
    }
    const addresschange = () => {
        personModel.addressKan = document.getElementById('addressKanA').value
        changedfield('addressKan');
    }
    const dateEndchange = () => {
        personModel.dateEndKan = document.getElementById('dateEndKanA').value
        changedfield('dateEndKan');
    }
    const dateBeginchange = () => {
        personModel.dateBeginKan = document.getElementById('dateBeginKanA').value
        changedfield('dateBeginKan');
    }
    const dateComingschange = () => {
        personModel.dateComingsKan = document.getElementById('dateComingsKanA').value
        changedfield('dateComingsKan');
    }
    const linechange = () => {
        personModel.lineKan = document.getElementById('lineKanA').value
        changedfield('lineKan');
    }
    const shifrchange = () => {
        personModel.shifrKan = document.getElementById('shifrKanA').value
        changedfield('shifrKan');
    }
    const descchange = () => {
        personModel.descKan = document.getElementById('descKanA').value
        changedfield('descKan');
    }

    const handleFocus = (event) => {
        closeAllHelp()
    };

    const sendSave = () => {
        blockUI()
        var path = ip + '/api/kan/addData';

        personModel.persons = []
        personModel.addresses = []
        personModel.auto = []
        personModel.company = []
        personModel.contact = []
        personModel.documents = []
        personModel.gun = []
        personModel.opm = []
        personModel.photo = []
        personModel.files = []
        personModel.traitor = []

        if (personModel.shifrKan == undefined || personModel.shifrKan == '') {
            showError('Шифр не може бути пустим')
            return;
          }
      
          if (personModel.lineKan == undefined || personModel.lineKan == '') {
            showError('Номер не може бути пустим')
            return;
          }
      

        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                }
            })
    }

    const sendRemove = (inner) => {
        blockUI()
        var path = ip + '/api/kan/removeData';

        var bd = encryptAes(JSON.stringify(inner))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);
                    document.getElementById("addeditems").innerHTML = "";
                    personModel = (result.data)
                    setView(result.data)

                }
            })
    }

    const handleSubmit = (e) => {
        sendSave()

        e.preventDefault();
    }

    const getAvatarToComponent = async(id, style, el) => {
        var path = ip + '/files/avatar';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);


                    var a = document.getElementById('image' + id)
                   

                    if (a !== null) {
                        a.src = 'data:image/png;base64,'+result.data
                        a.className = style
                      }
                       el.src = 'data:image/png;base64,'+result.data
                       el.className = style
                }
                
              
          }   
      )
    }

    const sendReSave = () => {
        blockUI()
        var path = ip + '/api/kan/addData';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    personModel = (result.data)
                    setView(result.data)

                }
            })
    }

    const sendPersonFullScreen = (id) => {
        window.open("/person?id=" + id)
    }

    const sendContactFullScreen = (id) => {
        window.open("/contact?id=" + id)
    }
    const sendOPMFullScreen = (id) => {
        window.open("/opm?id=" + id)
    }

    function clearPersonModel() {
        personModel.persons = []
        personModel.addresses = []
        personModel.auto = []
        personModel.company = []
        personModel.contact = []
        personModel.contacts = []
        personModel.documents = []
        personModel.gun = []
        personModel.guns = []
        personModel.opms = []
        personModel.opm = []
        personModel.photos = []
        personModel.photo = []
        personModel.files = []
        personModel.docs = []
        personModel.kan = []
        personModel.bs = []
        personModel.traitors = []
    }


    const changeSearch = (inner) => {

        var a = document.getElementById("foundItems");
        a.innerHTML = ""
        for (let index = 0; index < inner.length; index++) {
            var z = document.createElement('div'); // is a node
            var vv = document.createElement('div');
            vv.className = "itemAddView"
            z.style.display = "table";
            vv.style.display = "table-cell";
            inner[index].style = "table-cell"
            var vb = document.createElement('div');
            vb.className = "itemAddButton"
            vb.innerHTML = "<img width=\"100%\" src=\"" + plus + "\"/>"
            if (document.getElementById("Person").style.display == "block") {
                var temp = modelForAdd.person
                const cl = i => () => {
                    var b = true;
                    for (let j = 0; j < modelForAdd.person.length; j++) {
                        if (modelForAdd.person[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.persons.push(inner[index].value);
                        sendReSave()
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                vb.onclick = cl(inner[index].value)
            }

            if (document.getElementById("Contact").style.display == "block") {
                var temp = modelForAdd.contact
                const cl = i => () => {
                    var b = true;
                    for (let j = 0; j < modelForAdd.contact.length; j++) {
                        if (modelForAdd.contact[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.contact.push(inner[index].value);
                        sendReSave()
                        temp.push(inner[index])
                        changeAdded();
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                vb.onclick = cl(inner[index].value)
            }

            if (document.getElementById("OPM").style.display == "block") {
                var temp = modelForAdd.opm
                const cl = i => () => {
                    var b = true;
                    for (let j = 0; j < modelForAdd.opm.length; j++) {
                        if (modelForAdd.opm[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.opm.push(inner[index].value);
                        sendReSave()
                        temp.push(inner[index])
                        changeAdded();
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                vb.onclick = cl(inner[index].value)
            }

            vv.appendChild(vb)
            z.appendChild(vv);
            z.appendChild(inner[index]);
            a.appendChild(z);

        }
    }

    const resetModel = () => {
        modelForAdd = new ModelForAdd()
    };

    const setView = (pers, obj) => {
        document.getElementById('shifrKanA').value = pers.shifrKan
        document.getElementById('lineKanA').value = pers.lineKan
        document.getElementById('dateComingsKanA').value = pers.dateComingsKan
        document.getElementById('dateBeginKanA').value = pers.dateBeginKan
        document.getElementById('dateEndKanA').value = pers.dateEndKan
        document.getElementById('addressKanA').value = pers.addressKan
        document.getElementById('jobKanA').value = pers.jobKan
        document.getElementById('descKanA').value = pers.descKan
    
        editor.current.setContents(pers.infoKan)
        resetModel()
        if (pers.persons.length > 0) {

            for (let index = 0; index < pers.persons.length; index++) {
                addNewPerson(pers.persons[index].obj, false)
                modelForAdd.person[modelForAdd.person.length - 1].value.relDesk = pers.persons[index].text
                modelForAdd.person[modelForAdd.person.length - 1].value.relStatus = pers.persons[index].type

            }
        }

      
        if (pers.contacts.length > 0) {

            for (let index = 0; index < pers.contacts.length; index++) {
                addNewContact(pers.contacts[index].obj, false)
                modelForAdd.contact[modelForAdd.contact.length - 1].value.relDesk = pers.contacts[index].text
                modelForAdd.contact[modelForAdd.contact.length - 1].value.relStatus = pers.contacts[index].type

            }
        }

       
        if (pers.opms.length > 0) {

            for (let index = 0; index < pers.opms.length; index++) {
                addNewOPM(pers.opms[index].obj, false)
                modelForAdd.opm[modelForAdd.opm.length - 1].value.relDesk = pers.opms[index].text
                modelForAdd.opm[modelForAdd.opm.length - 1].value.relStatus = pers.opms[index].type

            }
        }

        if (pers.photos.length > 0) {

            for (let index = 0; index < pers.photos.length; index++) {
                addNewPhoto(pers.photos[index], false)

            }
        }

        if (pers.arch.length > 0) {

            for (let index = 0; index < pers.arch.length; index++) {
                  addNewFile(pers.arch[index], false)

            }
        }

      
        changeAdded()
    }

    const addNewPerson = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">";
        var sn = (pers.lastName == undefined || pers.lastName == '' ? "" : pers.lastName + " ") +
            (pers.firstName == undefined || pers.firstName == '' ? "" : pers.firstName + " ") +
            (pers.middleName == undefined || pers.middleName == '' ? "" : pers.middleName + " ");
        var sb = (pers.bDate == undefined || pers.bDate == '' ? "" : pers.bDate + " ") +
            (pers.bLocation == undefined || pers.bLocation == '' ? "" : pers.bLocation + " ");
        var sc = (pers.nationality == undefined || pers.nationality == '' ? "" : pers.nationality + " ") +
            (pers.citizen == undefined || pers.citizen == '' ? "" : pers.citizen + " ");
        s += (sn == undefined || sn == '' ? "" : sn + "<br>") +
            (sb == undefined || sb == '' ? "" : sb + "<br>") +
            (sc == undefined || sc == '' ? "" : sc + "<br>") +
            (pers.nikName == undefined || pers.nikName == '' ? "" : pers.nikName + "<br>");

        if (pers.criminal == undefined || pers.criminal == '') {
            pers.criminal = 'Ні'
        }

        if (pers.criminal == "Так") {
            s += "Cудимий<br>"
        }
        s += (pers.desc == undefined || pers.desc === '' ? "" : pers.desc + "<br>");
        z.innerHTML = s
        z.style.display = "block";

        z.value = Object.assign({}, pers);


        var p = Object.assign({}, pers);
        if (p.firstName == undefined || p.firstName == '') {
            z.value = pers
            p = pers

        }

        if (p.firstName == undefined || p.firstName == '') {
            showError('Ім\'я зв\'язка не може бути пустим')
            return;
        }

        if (p.lastName == undefined || p.lastName == '') {
            showError('Прізвище зв\'язка не може бути пустим')
            return;
        }

        if (p.middleName == undefined || p.middleName == '') {
            showError('По батькові зв\'язка не може бути пустим')
            return;
        }

        if (p.bDate == undefined || p.bDate == '') {
            showError('Рік народження зв\'язка не може бути пустим')
            return;
        }


        if (isNewAdd) {

            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""

            personModel.persons.push(z.value);

            sendReSave()
        } else {

            modelForAdd.person.push(z)

            changeAdded()
        }
    }

    const addNewContact = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">";
        var sn = (pers.contactKey == undefined || pers.contactKey == '' ? "" : pers.contactKey + ": <br>") +
            (pers.contactValue == undefined || pers.contactValue == '' ? "" : pers.contactValue + " ");
        s += (sn == undefined || sn == '' ? "" : sn + "<br>");
        s += (pers.descContact == undefined ? "" : pers.descContact + "<br>");
        z.innerHTML = s
        z.style.display = "block";
        z.value = Object.assign({}, pers);

        var p = Object.assign({}, pers);
        if (p.contactKey == undefined || p.contactKey == '') {
            z.value = pers
            p = pers

        }
        if (p.contactKey == undefined || p.contactKey == '') {
            showError('Тип не може бути пустим')
            return;
        }

        if (p.contactValue == undefined || p.contactValue == '') {
            showError('Значення не може бути пустим')
            return;
        }

        if (isNewAdd) {

            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""
            personModel.contact.push(z.value);

            sendReSave()
        } else {
            modelForAdd.contact.push(z)

            changeAdded()
        }
    }

    const addNewOPM = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">";
        var sn = (pers.numberOPM == undefined || pers.numberOPM == '' ? "" : pers.numberOPM + " ") +
            (pers.dateOPM == undefined || pers.dateOPM == '' ? "" : pers.dateOPM + " ");
        var sb = (pers.typeExecutor == undefined || pers.typeExecutor == '' ? "" : pers.typeExecutor + " ") +
            (pers.executor == undefined || pers.executor == '' ? "" : pers.executor + " ");
        var sc = (pers.ini_organ == undefined || pers.ini_organ == '' ? "" : pers.ini_organ + " ") +
            (pers.ini_direction == undefined || pers.ini_direction == '' ? "" : pers.ini_direction + " ") +
            (pers.ini_name == undefined || pers.ini_name == '' ? "" : pers.ini_name + " ");
        s += (sn == undefined || sn == '' ? "" : sn + "<br>") +
            (sb == undefined || sb == '' ? "" : sb + "<br>") +
            (sc == undefined || sc == '' ? "" : sc + "<br>");



        s += (pers.desc == undefined ? "" : pers.desc + "<br>");
        z.innerHTML = s
        z.style.display = "block";


        z.value = Object.assign({}, pers);

        var p = Object.assign({}, pers);

        if (p.numberOPM == undefined || p.numberOPM == '') {
            z.value = pers
            p = pers

        }

        if (p.numberOPM == undefined || p.numberOPM == '') {
            showError('Номер не може бути пустим')
            return;
        }

        if (p.dateOPM == undefined || p.dateOPM == '') {
            showError('Дата не може бути пустою')
            return;
        }

        if (p.typeExecutor == undefined || p.typeExecutor == '') {
            showError('Підрозділ виконавця не може бути пустим')
            return;
        }




        if (isNewAdd) {

            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""

            personModel.opm.push(z.value);

            sendReSave()
        } else {
            modelForAdd.opm.push(z)

            changeAdded()
        }
    }

    const addNewPhoto = (files, isNewAdd) => {
          
    
            var z = document.createElement('div'); // is a node
            z.className = "listItem"
            //d.className = 'prevView'
            var adr = document.createElement('div');
    
            
            var element = new Image();
           // element.src =  'data:image/png;base64,'+files.image
            
           // element.className = 'prevImage'
    
           element.src = loading
           element.className = 'prevImageSearchEmpty'
           if (element.id !== undefined) {
           element.id = 'image'+files.id
           
           getAvatarToComponent(files.id, 'prevImage', element)
          }
    
    
            z.appendChild(element)
    
            
            z.style.display = "block";
            var tt = {
              id: files.id,
              image: files.image,
              text: files.text
            }
            z.value = tt
            
            
            if (isNewAdd){
                
              clearPersonModel()
              z.value.relStatus = 0
              z.value.relDesk = ""
                  
                    personModel.photo.push(z.value);
                    
                  sendReSave(personModel)
    
                  
            } else {
      
              modelForAdd.photo.push(z)
            
            changeAdded()
    
            
            }
    }

    const addNewFile = (files, isNewAdd) => {
          
    
      var z = document.createElement('div'); // is a node
            z.className = "listItem"
            //d.className = 'prevView'
            var file = document.createElement('div');
    
            file.innerHTML = files.archive.fileName
    
            
    
            z.appendChild(file)
    
    
      
      z.style.display = "block";
      var tt = {
        id: files.archive.id,
        file: files.archive.file,
        text: files.text,
        fileName: files.archive.fileName
      }
      z.value = tt
      
      if (isNewAdd){
                
        clearPersonModel()
        z.value.relStatus = 0
        z.value.relDesk = ""
            
              personModel.files.push(z.value);
              
            sendReSave(personModel)
      } else {
    
        modelForAdd.files.push(z)
      
      changeAdded()
      }
      
      
    
    
    
    }

    const changeAdded = () => {

        var a = document.getElementById("addeditems");
        a.innerHTML = ""
        if (document.getElementById("Person").style.display == "block") {
            for (let index = 0; index < modelForAdd.person.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.person[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20000])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.person[index].value)
                var chekers = document.createElement('div');
                chekers.className = "chekers"
                var checkbox1 = createChecker()
                checkbox1.onchange = function () {
                    if (modelForAdd.person[index].value.relStatus == undefined) {
                        modelForAdd.person[index].value.relStatus = 0
                    }
                    modelForAdd.person[index].value.relStatus += (this.checked ? 1 : -1)
                    clearPersonModel()
                    personModel.persons.push(modelForAdd.person[index].value);
                    sendReSave()
                };

                chekers.appendChild(checkbox1);
                chekers.appendChild(createCheckerLabel('Зв\'язок', "checkbox1_" + modelForAdd.person[index].value));
                var checkbox2 = createChecker()
                checkbox2.onchange = function () {
                    if (modelForAdd.person[index].value.relStatus == undefined) {
                        modelForAdd.person[index].value.relStatus = 0
                    }
                    modelForAdd.person[index].value.relStatus += (this.checked ? 2 : -2)
                    clearPersonModel()
                    personModel.persons.push(modelForAdd.person[index].value);
                    sendReSave()
                };
                chekers.appendChild(document.createElement('br'));
                chekers.appendChild(checkbox2);
                chekers.appendChild(createCheckerLabel('Родина', "checkbox2_" + modelForAdd.person[index].value));
                chekers.appendChild(document.createElement('br'));
                var input = createCheckerInput()
                input.onkeyup = function (event) {
                    if (event.key === 'Enter') {
                        modelForAdd.person[index].value.relDesk = this.value
                        clearPersonModel()
                        personModel.persons.push(modelForAdd.person[index].value);
                        sendReSave()
                    }
                };
                chekers.appendChild(input);
                if (modelForAdd.person[index].value.relStatus == undefined) {
                    modelForAdd.person[index].value.relStatus = 0
                } else {
                    checkbox1.checked = modelForAdd.person[index].value.relStatus % 2 == 1
                    checkbox2.checked = modelForAdd.person[index].value.relStatus / 2 >= 1
                }
                if (modelForAdd.person[index].value.relDesk == undefined) {
                    modelForAdd.person[index].value.relDesk = ""
                } else {
                    input.value = modelForAdd.person[index].value.relDesk
                }
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.person[index].innerHTML;
                const dlcl = i => () => {
                   sendPersonFullScreen(i)
                }
                d.ondblclick = dlcl(modelForAdd.person[index].value.id);
                z.appendChild(d);
                z.appendChild(chekers);
                a.appendChild(z);
            }

        }

        if (document.getElementById("Contact").style.display == "block") {
            for (let index = 0; index < modelForAdd.contact.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.contact[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20004])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.contact[index].value)
                var chekers = document.createElement('div');
                chekers.className = "chekers"
                var checkbox1 = createChecker()
                checkbox1.onchange = function () {
                    if (modelForAdd.contact[index].value.relStatus == undefined) {
                        modelForAdd.contact[index].value.relStatus = 0
                    }
                    modelForAdd.contact[index].value.relStatus += (this.checked ? 1 : -1)
                    clearPersonModel()
                    personModel.contact.push(modelForAdd.contact[index].value);
                    sendReSave()
                };

                chekers.appendChild(checkbox1);
                chekers.appendChild(createCheckerLabel('Об\'єкт', "checkbox1_" + modelForAdd.contact[index].value));
                var checkbox2 = createChecker()
                checkbox2.onchange = function () {
                    if (modelForAdd.contact[index].value.relStatus == undefined) {
                        modelForAdd.contact[index].value.relStatus = 0
                    }
                    modelForAdd.contact[index].value.relStatus += (this.checked ? 2 : -2)
                    clearPersonModel()
                    personModel.contact.push(modelForAdd.contact[index].value);
                    sendReSave()
                };
                chekers.appendChild(document.createElement('br'));
                chekers.appendChild(checkbox2);
                chekers.appendChild(createCheckerLabel('Зв\'язок', "checkbox2_" + modelForAdd.contact[index].value));
                chekers.appendChild(document.createElement('br'));
                var input = createCheckerInput()
                input.onkeyup = function (event) {
                    if (event.key === 'Enter') {
                        modelForAdd.contact[index].value.relDesk = this.value
                        clearPersonModel()
                        personModel.contact.push(modelForAdd.contact[index].value);
                        sendReSave()
                    }
                };
                chekers.appendChild(input);
                if (modelForAdd.contact[index].value.relStatus == undefined) {
                    modelForAdd.contact[index].value.relStatus = 0
                } else {
                    checkbox1.checked = modelForAdd.contact[index].value.relStatus % 2 == 1
                    checkbox2.checked = modelForAdd.contact[index].value.relStatus / 2 >= 1
                }
                if (modelForAdd.contact[index].value.relDesk == undefined) {
                    modelForAdd.contact[index].value.relDesk = ""
                } else {
                    input.value = modelForAdd.contact[index].value.relDesk
                }
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.contact[index].innerHTML;
                const dlcl = i => () => {
                    sendContactFullScreen(i)
                 }
                 d.ondblclick = dlcl(modelForAdd.contact[index].value.id);
                z.appendChild(d);
                z.appendChild(chekers);
                a.appendChild(z);
            }

        }

        if (document.getElementById("OPM").style.display == "block") {
            for (let index = 0; index < modelForAdd.opm.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.opm[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20007])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.opm[index].value)
                var chekers = document.createElement('div');
                chekers.className = "chekers"
                var checkbox1 = createChecker()
                checkbox1.onchange = function () {
                    if (modelForAdd.opm[index].value.relStatus == undefined) {
                        modelForAdd.opm[index].value.relStatus = 0
                    }
                    modelForAdd.opm[index].value.relStatus += (this.checked ? 1 : -1)
                    clearPersonModel()
                    personModel.opm.push(modelForAdd.opm[index].value);
                    sendReSave()
                };

                chekers.appendChild(checkbox1);
                chekers.appendChild(createCheckerLabel('Об\'єкт', "checkbox1_" + modelForAdd.opm[index].value));
                var checkbox2 = createChecker()
                checkbox2.onchange = function () {
                    if (modelForAdd.opm[index].value.relStatus == undefined) {
                        modelForAdd.opm[index].value.relStatus = 0
                    }
                    modelForAdd.opm[index].value.relStatus += (this.checked ? 2 : -2)
                    clearPersonModel()
                    personModel.opm.push(modelForAdd.opm[index].value);
                    sendReSave()
                };
                chekers.appendChild(document.createElement('br'));
                chekers.appendChild(checkbox2);
                chekers.appendChild(createCheckerLabel('Зв\'язок', "checkbox2_" + modelForAdd.opm[index].value));
                chekers.appendChild(document.createElement('br'));
                var input = createCheckerInput()
                input.onkeyup = function (event) {
                    if (event.key === 'Enter') {
                        modelForAdd.opm[index].value.relDesk = this.value
                        clearPersonModel()
                        personModel.opm.push(modelForAdd.opm[index].value);
                        sendReSave()
                    }
                };
                chekers.appendChild(input);
                if (modelForAdd.opm[index].value.relStatus == undefined) {
                    modelForAdd.opm[index].value.relStatus = 0
                } else {
                    checkbox1.checked = modelForAdd.opm[index].value.relStatus % 2 == 1
                    checkbox2.checked = modelForAdd.opm[index].value.relStatus / 2 >= 1
                }
                if (modelForAdd.opm[index].value.relDesk == undefined) {
                    modelForAdd.opm[index].value.relDesk = ""
                } else {
                    input.value = modelForAdd.opm[index].value.relDesk
                }
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.opm[index].innerHTML;
                const dlcl = i => () => {
                    sendOPMFullScreen(i)
                 }
                 d.ondblclick = dlcl(modelForAdd.opm[index].value.id);
                z.appendChild(d);
                z.appendChild(chekers);
                a.appendChild(z);
            }

        }
        
        if (document.getElementById("MyDropzone").style.display == "block"){
        
        
                for (let index = 0; index < modelForAdd.photo.length; index++) {
                  var z = document.createElement('div'); // is a node
                  var vv = document.createElement('div');
                  vv.className = "itemAddView"
                  z.style.display = "table";
        
                  vv.style.display = "table-cell";
        
                  modelForAdd.photo[index].style = "table-cell"
        
        
                  
                  
                  var vb = document.createElement('div');
                  vb.className = "itemAddButton"
                  vb.innerHTML="<img width=\"100%\" src=\""+minus +"\"/>"
                  const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20009])
                        }
                    })
                }
                  vb.onclick = cl(modelForAdd.photo[index].value)
                  var chekers = document.createElement('div');
                  chekers.className = "chekers"
        
                  var input = createCheckerInput();
                  
                  input.onkeyup = function (event) {  
                    if(event.key === 'Enter'){
                      modelForAdd.photo[index].value.text = this.value
        
                      clearPersonModel()
                    personModel.photo.push(modelForAdd.photo[index].value);
                          
                    sendReSave(personModel) 
                    
                    }
                    
                    
                };
                  chekers.appendChild(input);
                  
                  if(modelForAdd.photo[index].value.text == undefined) {
                    modelForAdd.photo[index].value.text = ""
                  } else {
                    input.value = modelForAdd.photo[index].value.text
                  }
                  
                  vv.appendChild(vb)
        
        
                  /*const cl = i => () =>{
                    pp(i)
                  }*/
                  
                  //z.onclick = cl(pers.id)
                  z.appendChild(vv);
                  var d = document.createElement('div');
        
                  d.innerHTML = modelForAdd.photo[index].innerHTML;
                  d.ondblclick = modelForAdd.photo[index].ondblclick;
                  
                  z.appendChild(d);
                  z.appendChild(chekers);
                    a.appendChild(z);
                    
                    
                }
        
                for (let index = 0; index < modelForAdd.files.length; index++) {
                  var z = document.createElement('div'); // is a node
                  var vv = document.createElement('div');
                  vv.className = "itemAddView"
                  z.style.display = "table";
        
                  vv.style.display = "table-cell";
        
                  modelForAdd.files[index].style = "table-cell"
        
        
                  
                  
                  var vb = document.createElement('div');
                  vb.className = "itemAddButton"
                  vb.innerHTML="<img width=\"100%\" src=\""+minus +"\"/>"
                  const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20008])
                        }
                    })
                }
                  vb.onclick = cl(modelForAdd.files[index].value)
                  var chekers = document.createElement('div');
                  chekers.className = "chekers"
        
                  var input = createCheckerInput()
                  
                  input.onkeyup = function (event) {  
                    
                    if(event.key === 'Enter'){
                      modelForAdd.files[index].value.text = this.value
        
                  clearPersonModel()
                    personModel.files.push(modelForAdd.files[index].value);
                          
                    sendReSave(personModel) 

                    }
                    
                };
                  chekers.appendChild(input);
                  
                  if(modelForAdd.files[index].value.text == undefined) {
                    modelForAdd.files[index].value.text = ""
                  } else {
                    input.value = modelForAdd.files[index].value.text
                  }
                  
                  vv.appendChild(vb)
        
        
                  /*const cl = i => () =>{
                    pp(i)
                  }*/
                  
                  //z.onclick = cl(pers.id)
                  z.appendChild(vv);
                  var d = document.createElement('div');
        
                  d.innerHTML = modelForAdd.files[index].innerHTML;
                  d.ondblclick = modelForAdd.files[index].ondblclick;
                  
                  z.appendChild(d);
                  z.appendChild(chekers);
                    a.appendChild(z);
                    
                    
                }
        
              }
    }









    return (
        <div className="fixed inset-0 bg-black z-50">

            <div className="main">
                <div className="header">
                    <img src={logo} className="logo" alt="logo" />
                    <div className="title" onClick={mainSubmit}>SPACE</div>
                    <div className="subtitle">(edit) </div>

                </div>

                <div className="panel">

                    <button id="personsB" className="panelButtonActive-kan" onClick={profileSubmit} >
                        <img src={persons} className="panelImage" />
                    </button>
                    <button id="phoneInternerB" className="panelButton-kan" onClick={phoneInternerSubmit} >
                        <img src={phoneInterner} className="panelImage" />
                    </button>
                    <button id="eventB" className="panelButton-kan" onClick={eventSubmit} >
                        <img src={event} className="panelImage" />
                    </button>
                    <button id="clipB" className="panelButton-kan" onClick={clipSubmit} >
                        <img src={clip} className="panelImage" />
                    </button>
                </div>

                <div className="searchMenu">

                    <form onSubmit={handleSubmit} className="form">


                        <input id="saveButton" className="input-button-right" type="submit" value="Зберегти" />

                        <div id="descKanADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
              <input id="descKanA" className="input-text" tabIndex="5" name="login" type="text" onChange={descchange} placeholder="Опис" autoComplete="off"  onKeyDown={handleKeyPress} onFocus={handleFocus}/>
              <div id="descKanAList" className="list" />
            </div>

            <div id="jobKanADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
              <input id="jobKanA" className="input-text" tabIndex="4" name="login" type="text" onChange={jobchange} placeholder="Місце роботи" autoComplete="off"  onKeyDown={handleKeyPress} onFocus={handleFocus}/>
              <div id="jobKanAList" className="list" />
            </div>

            <div id="addressKanADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
              <input id="addressKanA" className="input-text" tabIndex="4" name="login" type="text" onChange={addresschange} placeholder="Адреса" autoComplete="off"  onKeyDown={handleKeyPress} onFocus={handleFocus}/>
              <div id="addressKanAList" className="list" />
            </div>

            <div id="dateEndKanADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
              <input id="dateEndKanA" className="input-text" tabIndex="3" name="login" type="text" onChange={dateEndchange} placeholder="Дата кінця контролю" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
              <div id="dateEndKanAList" className="list" />
            </div>

            <div id="dateBeginKanADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
              <input id="dateBeginKanA" className="input-text" tabIndex="2" name="login" type="text" onChange={dateBeginchange} placeholder="Дата початку контролю" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
              <div id="dateBeginKanAList" className="list" />
            </div>

            <div id="dateComingsKanADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
              <input id="dateComingsKanA" className="input-text" tabIndex="1" name="login" type="text" onChange={dateComingschange} placeholder="Дата надходження" autoComplete="off"  onKeyDown={handleKeyPress} onFocus={handleFocus}/>
              <div id="dateComingsKanAList" className="list" />
            </div>

            <div id="lineKanADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
              <input id="lineKanA" className="input-text" tabIndex="1" name="login" type="text" onChange={linechange} placeholder="Номер телефону" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
              <div id="lineKanAList" className="list" />
            </div>

            <div id="shifrKanADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
              <input id="shifrKanA" className="input-text" tabIndex="1" name="login" type="text" onChange={shifrchange} placeholder="Шифр" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
              <div id="shifrKanAList" className="list" />
            </div>


                    </form>

                </div>

                <div className="searc2hMenu" >
                    <div id="Person" className="menuItems" style={{ display: "block" }}>
                        <Person changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="Contact" className="menuItems" style={{ display: "none" }}>
                        <Contact changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="OPM" className="menuItems" style={{ display: "none" }}>
                        <OPM changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="MyDropzone" className="menuItems" style={{ display: "none" }}>
                        <MyDropzone addNew={addNew} />
                    </div>

                </div>


                <table width="100%" style={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }} >
                    <tbody>
                        <td style={{ width: "350px", maxWidth: "350px", overflow: "hidden", whiteSpace: "nowrap" }}>

                        </td>
                        <td style={{ width: "600px", maxWidth: "600px", overflow: "hidden", wordWrap: "break-word" }}>
                            <div id="addeditems">

                            </div>
                        </td>
                        <td id="tdline" style={{ width: "1px", maxWidth: "1px", overflow: "hidden" }}>
                            <div id="line">

                            </div>
                        </td>
                        <td style={{ width: "600px", maxWidth: "600px", overflow: "hidden", wordWrap: "break-word" }}>
                            <div id="foundItems">

                            </div>
                        </td>
                        <td style={{ width: "350px", maxWidth: "350px", overflow: "hidden", whiteSpace: "nowrap" }}>

                        </td>
                        <tr>
                            <td style={{ width: "350px" }}>

                            </td>
                            <td colSpan="3" id="suneditor" >

                                <SunEditor getSunEditorInstance={getSunEditorInstance}
                                    id="textView" name="textView" height="300px" setOptions={{
                                        pasteTagsWhitelist: 'p,br,ul,ol,li,strong,b,em,i,span,div',
                                        addTagsWhitelist: 'p,br,ul,ol,li,strong,b,em,i,span,div',
                                        pastePlain: false,
                                        pasteImage: false,
                                        removeFormat: {
                                        tag: 'font',
                                        class: 'Mso*', 
                                        style: 'color,background-color,font-family'
                                        },
                                        buttonList: [['undo', 'redo',
                                            'font', 'fontSize', 'formatBlock',
                                            'paragraphStyle', 'blockquote', 'textStyle'
                                        ], ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript',
                                            'fontColor', 'hiliteColor',
                                            'outdent', 'indent',
                                            'align', 'horizontalRule', 'list', 'lineHeight']]
                                    }}
                                    setAllPlugins={true}
                                    setDefaultStyle="font-family: Arial; font-size: 14px; text-align: justify;"
                                    onChange={content => {

                                        personModel.infoKan = content
                                        // console.log(content)

                                    }} />

                            </td>
                            <td style={{ width: "350px" }}>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            ({isBlocked && <div className={`black ${isBlocked ? "show" : ""}`}>
                <img src={loading} alt="logo" />

            </div>
            })
        </div>

    );
}


export default KanEdit;